import { render, staticRenderFns } from "./HeaderLanguageMenu.vue?vue&type=template&id=dbe4b46a&scoped=true&"
import script from "./HeaderLanguageMenu.vue?vue&type=script&lang=js&"
export * from "./HeaderLanguageMenu.vue?vue&type=script&lang=js&"
import style0 from "./HeaderLanguageMenu.vue?vue&type=style&index=0&id=dbe4b46a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe4b46a",
  null
  
)

export default component.exports